import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/translatorDefaultPhoto.png'
import _imports_1 from '../../../assets/images/logo_black.svg'
import _imports_2 from '@/assets/icons/attachment.svg'
import _imports_3 from '../../../assets/icons/remove.svg'
import _imports_4 from '../../../assets/icons/add_more_dates.svg'


const _withScopeId = n => (_pushScopeId("data-v-2c739770"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex bg-white py-4 px-4 md:pt-16 md:pb-6 md:px-6 flex-col md:mx-6 mt-10" }
const _hoisted_2 = { class: "flex flex-col md:flex-row gap-8 border-b border-b-[#E0E0E0] mb-8 md:pb-6 relative" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "flex w-full flex-col" }
const _hoisted_5 = { class: "hidden md:block" }
const _hoisted_6 = { class: "flex w-full justify-between" }
const _hoisted_7 = { class: "font-bold text-2xl pb-4 break-words" }
const _hoisted_8 = { class: "break-word" }
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = ["alt"]
const _hoisted_11 = { class: "mt-4" }
const _hoisted_12 = {
  for: "message",
  class: "block mb-2 text-sm font-normal text-gray-900 dark:text-gray-500"
}
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = { class: "control__error" }
const _hoisted_15 = { class: "md:hidden" }
const _hoisted_16 = { class: "font-bold text-2xl break-words flex justify-between mb-4 after:w-full after:bg-[#DEDEDE] after:block after:absolute after:h-px after:left-0 after:top-16" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "flex w-full justify-between items-center mt-8" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "translator-image-small block self-baseline mr-5 min-w-[84px] h-[84px] object-cover rounded-full"
}, null, -1))
const _hoisted_20 = { class: "flex w-full flex-col md:flex-row flex-wrap md:gap-6" }
const _hoisted_21 = { class: "item" }
const _hoisted_22 = {
  for: "language",
  class: "block mb-1.5 text-sm font-normal text-gray-900 dark:text-gray-500"
}
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "item" }
const _hoisted_25 = {
  for: "formOfTranslation",
  class: "block mb-1.5 text-sm font-normal text-gray-900 dark:text-gray-500"
}
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "item" }
const _hoisted_28 = {
  for: "typeOfTranslation",
  class: "block mb-1.5 text-sm font-normal text-gray-900 dark:text-gray-500"
}
const _hoisted_29 = ["value"]
const _hoisted_30 = {
  key: 0,
  class: "item"
}
const _hoisted_31 = {
  for: "deadline",
  class: "block mb-2 text-sm font-normal text-gray-900 dark:text-gray-500"
}
const _hoisted_32 = {
  key: 0,
  class: "control__error"
}
const _hoisted_33 = { class: "item" }
const _hoisted_34 = {
  for: "deliveryMethod",
  class: "block mb-2 text-sm font-normal text-gray-900 dark:text-gray-500"
}
const _hoisted_35 = ["value"]
const _hoisted_36 = { class: "item" }
const _hoisted_37 = {
  for: "receivingMethod",
  class: "block mb-2 text-sm font-normal text-gray-900 dark:text-gray-500"
}
const _hoisted_38 = ["value"]
const _hoisted_39 = { class: "item" }
const _hoisted_40 = {
  for: "paymentMethod",
  class: "block mb-1.5 text-sm font-normal text-gray-900 dark:text-gray-500"
}
const _hoisted_41 = ["value"]
const _hoisted_42 = {
  key: 2,
  class: "item"
}
const _hoisted_43 = {
  for: "documentFile",
  class: "block mb-2 text-sm font-normal text-gray-900 dark:text-gray-500"
}
const _hoisted_44 = ["placeholder", "accept"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "absolute top-1/2 right-3.5 -translate-y-2/4",
  src: _imports_2
}, null, -1))
const _hoisted_46 = { class: "control__error" }
const _hoisted_47 = { class: "item-full" }
const _hoisted_48 = {
  for: "address",
  class: "block mb-2 text-sm font-normal text-gray-900 dark:text-gray-500"
}
const _hoisted_49 = {
  key: 0,
  class: "control__error"
}
const _hoisted_50 = { class: "item-30 w-full lg:w-auto" }
const _hoisted_51 = {
  for: "date",
  class: "block mb-2 text-sm font-normal text-gray-900 dark:text-gray-500"
}
const _hoisted_52 = ["name", "onUpdate:modelValue", "aria-describedby"]
const _hoisted_53 = {
  key: 0,
  class: "control__error"
}
const _hoisted_54 = ["id"]
const _hoisted_55 = { class: "item-15 min-w-[90px]" }
const _hoisted_56 = {
  for: "fromTime",
  class: "block mb-2 text-sm font-normal text-gray-900 dark:text-gray-500"
}
const _hoisted_57 = ["name", "onUpdate:modelValue", "aria-describedby"]
const _hoisted_58 = {
  key: 0,
  class: "control__error"
}
const _hoisted_59 = ["id"]
const _hoisted_60 = { class: "item-15 min-w-[90px]" }
const _hoisted_61 = {
  for: "toTime",
  class: "block mb-2 text-sm font-normal text-gray-900 dark:text-gray-500"
}
const _hoisted_62 = ["name", "onUpdate:modelValue"]
const _hoisted_63 = {
  key: 0,
  class: "control__error"
}
const _hoisted_64 = ["id"]
const _hoisted_65 = ["onClick", "id"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "pr-2.5",
  src: _imports_3
}, null, -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Usuń datę ", -1))
const _hoisted_68 = [
  _hoisted_66,
  _hoisted_67
]
const _hoisted_69 = ["onClick", "id"]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "pr-2.5",
  src: _imports_4
}, null, -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Więcej dat ", -1))
const _hoisted_72 = [
  _hoisted_70,
  _hoisted_71
]
const _hoisted_73 = { class: "md:hidden mt-6 md:mt-0" }
const _hoisted_74 = {
  for: "message",
  class: "block mb-2 text-sm font-normal text-gray-900 dark:text-gray-500"
}
const _hoisted_75 = { class: "control__error" }
const _hoisted_76 = { class: "md:flex gap-8 hidden" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "md:flex-1" }, null, -1))
const _hoisted_78 = { class: "flex md:flex-1 gap-6" }

import {toRefs, watch, withDefaults, ref, computed, onMounted, inject, reactive} from "vue";
import {VueFinalModal} from "vue-final-modal";
import ButtonPrimary from "@/components/atoms/ButtonPrimary.vue";
import axios from "axios";
import ApiHelper from "@/helpers/apiHelper";
import {useField, useForm} from "vee-validate";
import * as yup from "yup";
import i18n from "@/i18n";
import authHelper from "@/helpers/authHelper";
import alertHelper from "@/helpers/alertHelper";
import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  __name: 'sendInquiriesModal',
  props: {
    showTranslatorRequestModal: { type: Boolean, default: false },
    translator: null
  },
  emits: ['update:showTranslatorRequestModal', 'cancel'],
  setup(__props: any, { emit }) {

const props = __props as { showTranslatorRequestModal: boolean, translator: object }

const WRITTEN_FORM = 1;
const INTERPRETING_FORM = 2;


const {showAlert} = alertHelper();



const {showTranslatorRequestModal, translator}: {showTranslatorRequestModal: any, translator: any} = toRefs(props),
    result: any = ref([]),
    language = ref(),
    typeOfTranslation: any = ref(0),
    paymentMethods: any = ref(1),
    deliveryMethod = ref(1),
    receiptTranslation = ref(1),
    sendingForm = ref(false),
    documentFile: any = ref(),
    supportedFormat = ref(''),
    maxFileSize = ref(),
    maximumFiles = ref(),
    maximumSize = ref(),
    filesError = ref(''),
    totalFiles = ref(0);

let filesToUpload: Array<{
    size?: number,
    name?: string
}>  = [];

const { handleSubmit, errors, resetForm } = useForm({
    validationSchema: yup.object().shape({
        formOfTranslation: yup.number()
            .required(i18n.global.t('validation.required')),
        address: yup.string()
            .trim()
            .when('formOfTranslation', {
                is: INTERPRETING_FORM,
                then: yup.string().required(i18n.global.t('validation.required')),
            }),
        message: yup.string()
            .trim()
            .required(i18n.global.t('validation.required')),
        deadline: yup.date()
            .nullable()
            .default(null)
            .typeError(i18n.global.t('validation.required'))
            .when("formOfTranslation", {
                is: WRITTEN_FORM,
                then: yup.date().required(i18n.global.t('validation.required'))
                    .typeError(i18n.global.t('validation.required'))
            }),
        addMoreDates: yup.array().of(
            yup.object().shape({
                date: yup.date()
                    .nullable()
                    .required(i18n.global.t('validation.required')),
                fromTime: yup.string()
                    .matches(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, i18n.global.t('validation.invalidFormat'))
                    .nullable()
                    .required(i18n.global.t('validation.required')),
                    // .typeError(i18n.global.t('validation.required')),
                toTime: yup.string()
                    .nullable()
                    .required(i18n.global.t('validation.required'))
                    .matches(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, i18n.global.t('validation.invalidFormat')),
                    // .typeError(i18n.global.t('validation.required')),
            })
        ),
    }),
    initialValues: {
        address: '',
        message: '',
        deadline: moment().format('YYYY-MM-DD'),
        formOfTranslation: WRITTEN_FORM,
        addMoreDates: [{
            date: moment().format('YYYY-MM-DD'),
            fromTime: moment().format('hh:mm'),
            toTime: moment().format('hh:mm'),
            showAddButton: true,
        }],
    }
});

const { value: address } = useField('address');
const { value: message } = useField('message');
const { value: deadline } = useField('deadline');
const { value: formOfTranslation } = useField('formOfTranslation');
const { value: addMoreDates, handleChange: handleAddMoreDates } = useField('addMoreDates');

const changeInputFile = function (event) {
    filesToUpload = documentFile.value.files;
    let totalSizes = 0;

    filesError.value = '';
    for (let i = 0; i < filesToUpload.length; i++) {
        const fileSize = Number(formatBytes(filesToUpload[i].size));
        totalSizes += fileSize;

        if(fileSize > maxFileSize.value) {
            filesError.value = i18n.global.t('validation.maxFileSize',{'fileName':filesToUpload[i].name })
        }

        if(i > maximumFiles.value - 1) {
            filesError.value = i18n.global.t('validation.maximumFiles', {'maxFiles': maximumFiles.value})
        }

        if(totalSizes > maximumSize.value) {
            filesError.value = i18n.global.t('validation.maximumSize', {'maximumSize': maximumSize.value })
        }

        totalFiles.value = i + 1;
    }
}

const onSubmit = handleSubmit(async values => {
    sendingForm.value = true;

    const dates: any = [];
    for(let i = 0; i < addMoreDates.value.length; i++) {
        dates.push({
            date: addMoreDates.value[i].date,
            timeFrom: addMoreDates.value[i].fromTime,
            timeTo: addMoreDates.value[i].toTime
        })
    }
    let data: any = '';
    let url = '';

    if(formOfTranslation.value == INTERPRETING_FORM) {
        url = ApiHelper.getInquiriesInterpretingUrl(translator.value.basicInfo.id);

        data = {
            message: message.value,
            languageId: language.value,
            typeOfTranslationId: typeOfTranslation.value,
            paymentMethodId: paymentMethods.value,
            address: address.value,
            dates: dates
        };
    }
    else if(formOfTranslation.value == WRITTEN_FORM) {
        url = ApiHelper.getInquiriesWrittenUrl(translator.value.basicInfo.id);

        data = {
            message: message.value,
            languageId: language.value,
            typeOfTranslationId: typeOfTranslation.value,
            deadline: deadline.value,
            originalDocumentDeliveryId: deliveryMethod.value,
            receiptOfTranslationId: receiptTranslation.value,
            paymentMethodId: paymentMethods.value,
            attachments: []
        };
    }

    for (let i = 0; i < filesToUpload.length; i++) {
        let formData = new FormData();
        formData.append("file", filesToUpload[i]);
        const files = await axios.post(
                ApiHelper.getAddFileUrl(), formData,{headers: {'Authorization': authHelper.authHeader()}}
            ).catch(error => {
                sendingForm.value = false;
                showAlert(i18n.global.t('translatorPage.form.errorSendInquiry'), '','error');
            })
        ;
        data.attachments.push({
            fileId: files.data.details.fileId,
            extension: files.data.details.extension,
            name: files.data.details.name,
        })
    }


    await axios.post(url, data, {headers: {'Authorization': authHelper.authHeader()}})
        .then(result => {
            showAlert(i18n.global.t('translatorPage.form.successfullySendInquiry'));
            sendingForm.value = false;
            emit('update:showTranslatorRequestModal',false);
            emit('cancel');
        })
        .catch(error => {
            sendingForm.value = false;
            showAlert(i18n.global.t('translatorPage.form.errorSendInquiry'), '','error');
        })
}, (err) => {
    console.log('ERROR SUBMIT',err)

});

const getLanguages = computed(() => {
    let firstItem = true;
    if(Object.keys(result.value).length)
        return result.value.map((item: {name: string, id: number}) => {

            if(firstItem) {
                language.value = item.id;
                firstItem = false;
            }

            return {
                id: item.id,
                name: item.name
            }
        });
    else
        return  [];
});

const getFormOfTranslation = computed(() => {

    if(language.value == '')
        return [];

    else {
        let map = [];
        if(Object.keys(result.value).length) {
            const key = result.value.find(item => item.id == language.value);
            map = key.formsOfTranslation.map((item: { name: string, id: number }) => {
                return {
                    id: item.id,
                    name: item.name
                }
            });
        }

        return map;
    }
})

const getTypesOfTranslation = computed(() => {
    if(language.value == '')
        return [];

    else {
        let map = [];
        if(Object.keys(result.value).length) {
            const key = result.value.find(item => item.id == language.value);
            map = key.typesOfTranslation.map((item: { name: string, id: number }) => {
                return {
                    id: item.id,
                    name: item.name
                }
            });
        }

        return map;
    }
});

const getPaymentMethods = computed(() => {
    if(language.value == '')
        return [];

    else {
        let map = [];
        if(Object.keys(result.value).length) {
            const key = result.value.find(item => item.id == language.value);
            map = key.paymentMethods.map((item: { name: string, id: number }) => {
                return {
                    id: item.id,
                    name: item.name
                }
            });
        }

        return map;
    }
});

const getReceiptOfTranslations = computed(() => {
    if(language.value == '')
        return [];

    else {
        let map = [];
        if(Object.keys(result.value).length) {
            const key = result.value.find(item => item.id == language.value);
            map = key.receiptOfTranslations.map((item: { name: string, id: number }) => {
                return {
                    id: item.id,
                    name: item.name
                }
            });
        }

        return map;
    }
});

const getOriginalDocumentsDelivery = computed(() => {
    if(language.value == '')
        return [];

    else {
        let map = [];
        if(Object.keys(result.value).length) {
            const key = result.value.find(item => item.id == language.value);
            map = key.originalDocumentsDelivery.map((item: { name: string, id: number }) => {
                return {
                    id: item.id,
                    name: item.name
                }
            });
        }

        return map;
    }
});

function moreDates(key) {
    addMoreDates.value[key].showAddButton = false;
    addMoreDates.value.push({
        date: '',
        fromTime: '',
        toTime: '',
        showAddButton: true,
    });
}

function removeDates(key) {
    addMoreDates.value.splice(key,1)
}

function formatBytes (bytes, decimals = 2) {
    return (bytes / (1024 * 1024)).toFixed(decimals);
}

async function getParams() {
    await axios.get(ApiHelper.getParamsForSendRequestForTranslator(translator.value.basicInfo.id),{headers: {'Authorization': authHelper.authHeader()}}).then((res) => {
        result.value = res.data.languages;
    })
}

async function getSupportedFormat() {
    await axios.get(ApiHelper.getSupportedFormatFilesUrl(), {headers: {'Authorization': authHelper.authHeader()}})
        .then((res) => {
            console.log('red',res)
            let extensions = '';
            res.data.formats.forEach(el => extensions += el.extension + ', ');
            extensions = extensions.slice(0, -2);
            supportedFormat.value = extensions;

            maxFileSize.value = res.data.maximumFileSize;
            maximumFiles.value = res.data.maximumFiles;
            maximumSize.value = res.data.maximumSize;
        })
        .catch(error => {
            console.log('ERR',error);
        })
}

onMounted(() => {
    getParams();
    getSupportedFormat();
})


// watch(showTranslatorRequestModal, (curr,old) => {
//
// });



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueFinalModal), _mergeProps({
    modelValue: _unref(showTranslatorRequestModal),
    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_isRef(showTranslatorRequestModal) ? (showTranslatorRequestModal).value = $event : null)),
    classes: "h-100 overflow-y-scroll",
    "focus-retain": true,
    "focus-trap": false
  }, _ctx.$attrs, { "esc-to-close": true }), {
    default: _withCtx(({ close }) => [
      _createElementVNode("form", {
        onSubmit: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "absolute text-[#767676] right-0 -top-10 cursor-pointer",
              onClick: ($event: any) => (_ctx.$emit('cancel', close))
            }, "X", 8, _hoisted_3),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t('translatorPage.form.sendInquiryTo')), 1),
                    _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(translator)?.basicInfo?.name), 1)
                  ]),
                  (_unref(translator)?.basicInfo?.profileImgUrl)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _unref(translator)?.basicInfo?.profileImgUrl,
                        alt: _ctx.$t('translatorPage.translatorImageAlt'),
                        class: "min-w-[84px] h-[84px] object-cover rounded-full"
                      }, null, 8, _hoisted_9))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: _imports_0,
                        alt: _ctx.$t('translatorPage.translatorImageAlt'),
                        class: "min-w-[84px] h-[84px] object-cover rounded-full"
                      }, null, 8, _hoisted_10))
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('translatorPage.form.yourMessage')), 1),
                  _withDirectives(_createElementVNode("textarea", {
                    id: "message",
                    name: "message",
                    placeholder: _ctx.$t('translatorPage.form.enterMessagePlaceholder'),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(message) ? (message).value = $event : null)),
                    class: _normalizeClass([{'input-error': _unref(errors).message}, "bg-gray-100 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block w-full p-4 select-arrow h-60"])
                  }, null, 10, _hoisted_13), [
                    [_vModelText, _unref(message)]
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", null, _toDisplayString(_unref(errors).message), 1)
                  ], 512), [
                    [_vShow, _unref(errors).message]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.$t('translatorPage.sendRequest')), 1),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.$emit('cancel', close)),
                    class: "text-sm text-[#767676]"
                  }, "X", 8, _hoisted_17)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('translatorPage.sendRequestTo')) + ": " + _toDisplayString(_unref(translator)?.basicInfo?.name), 1),
                  _hoisted_19
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('translatorPage.form.language')), 1),
                _withDirectives(_createElementVNode("select", {
                  class: "bg-gray-100 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block w-full p-3.5 select-arrow capitalize",
                  id: "language",
                  name: "language",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((language).value = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getLanguages), (lang, key) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: key,
                      value: lang.id
                    }, _toDisplayString(lang.name), 9, _hoisted_23))
                  }), 128))
                ], 512), [
                  [_vModelSelect, language.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('translatorPage.form.formOfTranslation')), 1),
                _withDirectives(_createElementVNode("select", {
                  class: "bg-gray-100 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block w-full p-3.5 select-arrow",
                  id: "formOfTranslation",
                  name: "formOfTranslation",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(formOfTranslation) ? (formOfTranslation).value = $event : null))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getFormOfTranslation), (lang, key) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: key,
                      value: lang.id
                    }, _toDisplayString(lang.name), 9, _hoisted_26))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _unref(formOfTranslation)]
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('translatorPage.form.kindOf')), 1),
                _withDirectives(_createElementVNode("select", {
                  class: "bg-gray-100 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block w-full p-3.5 select-arrow",
                  id: "typeOfTranslation",
                  name: "typeOfTranslation",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((typeOfTranslation).value = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getTypesOfTranslation), (lang, key) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: key,
                      value: lang.id
                    }, _toDisplayString(lang.name), 9, _hoisted_29))
                  }), 128))
                ], 512), [
                  [_vModelSelect, typeOfTranslation.value]
                ])
              ]),
              (_unref(formOfTranslation) === WRITTEN_FORM)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.$t('translatorPage.form.deadline')), 1),
                    _withDirectives(_createElementVNode("input", {
                      class: _normalizeClass(["bg-gray-100 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block w-full p-3.5 select-arrow", {error: _unref(errors).deadline}]),
                      id: "deadline",
                      name: "deadline",
                      type: "date",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(deadline) ? (deadline).value = $event : null)),
                      onChange: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (deadline.value = _unref(deadline) && _unref(deadline) != '' ? _unref(deadline) : null), ["prevent"]))
                    }, null, 34), [
                      [_vModelText, _unref(deadline)]
                    ]),
                    (_unref(errors).deadline)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _createElementVNode("div", null, _toDisplayString(_unref(errors).deadline), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_unref(formOfTranslation) === WRITTEN_FORM)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.$t('translatorPage.form.deliveryMethod')), 1),
                      _withDirectives(_createElementVNode("select", {
                        class: "bg-gray-100 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block w-full p-3.5 select-arrow",
                        id: "deliveryMethod",
                        name: "deliveryMethod",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((deliveryMethod).value = $event))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getOriginalDocumentsDelivery), (lang, key) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: key,
                            value: lang.id
                          }, _toDisplayString(lang.name), 9, _hoisted_35))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, deliveryMethod.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('translatorPage.form.receivingMethod')), 1),
                      _withDirectives(_createElementVNode("select", {
                        class: "bg-gray-100 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block w-full p-3.5 select-arrow",
                        id: "receivingMethod",
                        name: "receivingMethod",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((receiptTranslation).value = $event))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getReceiptOfTranslations), (lang, key) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: key,
                            value: lang.id
                          }, _toDisplayString(lang.name), 9, _hoisted_38))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, receiptTranslation.value]
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('translatorPage.form.paymentMethod')), 1),
                _withDirectives(_createElementVNode("select", {
                  class: "bg-gray-100 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block w-full p-3.5 select-arrow",
                  id: "paymentMethod",
                  name: "paymentMethod",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((paymentMethods).value = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getPaymentMethods), (lang, key) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: key,
                      value: lang.id
                    }, _toDisplayString(lang.name), 9, _hoisted_41))
                  }), 128))
                ], 512), [
                  [_vModelSelect, paymentMethods.value]
                ])
              ]),
              (_unref(formOfTranslation) === WRITTEN_FORM)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.$t('translatorPage.form.documentFile')), 1),
                    _createElementVNode("input", {
                      class: "hidden bg-gray-100 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block w-full p-3.5 select-arrow",
                      id: "documentFile",
                      name: "documentFile",
                      type: "file",
                      placeholder: _ctx.$t('translatorPage.form.addFilePlaceholder'),
                      ref_key: "documentFile",
                      ref: documentFile,
                      accept: supportedFormat.value,
                      multiple: "",
                      onChange: _cache[9] || (_cache[9] = ($event: any) => (changeInputFile($event)))
                    }, null, 40, _hoisted_44),
                    _createElementVNode("div", {
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$refs.documentFile.click())),
                      class: "relative min-h-[47px] bg-gray-100 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block w-full p-3.5 select-arrow"
                    }, [
                      (totalFiles.value > 0 && filesError.value == '')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.$t('translatorPage.form.chooseFile')) + " " + _toDisplayString(totalFiles.value), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.$t('translatorPage.form.addFile')), 1)
                          ], 64)),
                      _hoisted_45
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", null, _toDisplayString(filesError.value), 1)
                    ], 512), [
                      [_vShow, filesError.value]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_unref(formOfTranslation) === INTERPRETING_FORM)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.$t('translatorPage.form.address')), 1),
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass(["bg-gray-100 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block w-full p-3.5 select-arrow", {error: _unref(errors).address}]),
                        id: "address",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(address) ? (address).value = $event : null))
                      }, null, 2), [
                        [_vModelText, _unref(address)]
                      ]),
                      (_unref(errors).address)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                            _createElementVNode("div", null, _toDisplayString(_unref(errors).address), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(addMoreDates), (item, key) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "flex md:gap-6 flex-wrap flex-col md:flex-row w-full",
                        key: item
                      }, [
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.$t('translatorPage.form.date')), 1),
                          _withDirectives(_createElementVNode("input", {
                            class: "bg-gray-100 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block w-full p-3.5 select-arrow",
                            id: "date",
                            name: `date[${key}]`,
                            type: "date",
                            "onUpdate:modelValue": ($event: any) => ((item.date) = $event),
                            "aria-describedby": `error_addMoreDates[${key}].date`,
                            "aria-required": "true"
                          }, null, 8, _hoisted_52), [
                            [_vModelText, item.date]
                          ]),
                          (_unref(errors) && _unref(errors)[`addMoreDates[${key}].date`])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                _createElementVNode("div", {
                                  id: `error_addMoreDates[${key}].date`
                                }, _toDisplayString(_unref(errors)[`addMoreDates[${key}].date`]), 9, _hoisted_54)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.$t('translatorPage.form.fromTime')), 1),
                          _withDirectives(_createElementVNode("input", {
                            class: "bg-gray-100 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block w-full p-3.5 select-arrow",
                            id: "fromTime",
                            name: `fromTime[${key}]`,
                            type: "time",
                            "onUpdate:modelValue": ($event: any) => ((item.fromTime) = $event),
                            "aria-describedby": `error_addMoreDates[${key}].fromTime`,
                            "aria-required": "true"
                          }, null, 8, _hoisted_57), [
                            [_vModelText, item.fromTime]
                          ]),
                          (_unref(errors) && _unref(errors)[`addMoreDates[${key}].fromTime`])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                _createElementVNode("div", {
                                  id: `error_addMoreDates[${key}].fromTime`
                                }, _toDisplayString(_unref(errors)[`addMoreDates[${key}].fromTime`]), 9, _hoisted_59)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_60, [
                          _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.$t('translatorPage.form.toTime')), 1),
                          _withDirectives(_createElementVNode("input", {
                            class: "bg-gray-100 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block w-full p-3.5 select-arrow",
                            id: "toTime",
                            name: `toTime[${key}]`,
                            type: "time",
                            "onUpdate:modelValue": ($event: any) => ((item.toTime) = $event)
                          }, null, 8, _hoisted_62), [
                            [_vModelText, item.toTime]
                          ]),
                          (_unref(errors) && _unref(errors)[`addMoreDates[${key}].toTime`])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                _createElementVNode("div", {
                                  id: `error_addMoreDates[${key}].toTime`
                                }, _toDisplayString(_unref(errors)[`addMoreDates[${key}].toTime`]), 9, _hoisted_64)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _withDirectives(_createElementVNode("div", {
                          class: "item-30 flex items-center mt-6 min-w-[90px]",
                          onClick: ($event: any) => (removeDates(key)),
                          id: 'remove-dates-'+item
                        }, _hoisted_68, 8, _hoisted_65), [
                          [_vShow, !_unref(addMoreDates)[key].showAddButton]
                        ]),
                        _withDirectives(_createElementVNode("div", {
                          class: "item-30 flex items-center mt-6 min-w-[90px]",
                          onClick: ($event: any) => (moreDates(key)),
                          id: 'more-dates-'+item
                        }, _hoisted_72, 8, _hoisted_69), [
                          [_vShow, _unref(addMoreDates)[key].showAddButton]
                        ])
                      ]))
                    }), 128))
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("label", _hoisted_74, _toDisplayString(_ctx.$t('translatorPage.form.contentMessage')), 1),
                _withDirectives(_createElementVNode("textarea", {
                  id: "message",
                  name: "message",
                  placeholder: "Wpisz treść",
                  class: _normalizeClass(["bg-gray-100 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block w-full p-4 select-arrow h-60", {error: _unref(errors).message}]),
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_isRef(message) ? (message).value = $event : null))
                }, null, 2), [
                  [_vModelText, _unref(message)]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_75, [
                  _createElementVNode("div", null, _toDisplayString(_unref(errors).message), 1)
                ], 512), [
                  [_vShow, _unref(errors).message]
                ])
              ])
            ])
          ]),
          _createVNode(ButtonPrimary, {
            type: "submit",
            name: "Wyślij",
            class: _normalizeClass(["w-full md:hidden", {'cursor-not-allowed': sendingForm.value}]),
            disabled: sendingForm.value
          }, null, 8, ["class", "disabled"]),
          _createElementVNode("div", _hoisted_76, [
            _hoisted_77,
            _createElementVNode("div", _hoisted_78, [
              _createVNode(ButtonPrimary, {
                name: _ctx.$t('translatorPage.form.cancel'),
                class: "w-full",
                outlined: "",
                onClick: ($event: any) => (_ctx.$emit('cancel', close)),
                type: "button"
              }, null, 8, ["name", "onClick"]),
              _createVNode(ButtonPrimary, {
                type: "submit",
                name: _ctx.$t('translatorPage.form.send'),
                class: _normalizeClass(["w-full", {'cursor-not-allowed': sendingForm.value}]),
                disabled: sendingForm.value
              }, null, 8, ["name", "class", "disabled"])
            ])
          ])
        ])
      ], 32)
    ]),
    _: 1
  }, 16, ["modelValue"]))
}
}

})